import BaseViz from './BaseViz'
import CandleStickChart from '../charts/CandleStickChart'
import CandleStickDataController from '../viz_behaviors/CandleStickDataController'
export default class CandleStickViz extends BaseViz {
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: true,
        nonEditable: true,
      },
      interactive: {
        nonEditable: true,
        exposed: false,
      },
    },
    ItemsHelper: {
      colorScale: {
        nonEditable: true,
      },
      colorDict: {
        nonEditable: true,
      },
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        showTickValues: {
          nonEditable: true,
        },
        trimThreshold: {
          nonEditable: true,
        },
      },
      zoomAxes: ['x'],
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `<div> 
        open: ${this.formatTooltipValue(d.open)}<br/>
        close: ${this.formatTooltipValue(d.close)}<br/>
        low: ${this.formatTooltipValue(d.low)}<br/>
        high: ${this.formatTooltipValue(d.high)}</div>
        <div class="secondary">${d.id}</div>
        `
      },
    },
  }

  static chartClass = CandleStickChart
  static dataControllerClass = CandleStickDataController
}
